import { Injectable } from '@angular/core';
import { HttpService } from '../../../core/services/http/http.service';
import { Store } from '@ngrx/store';
import { AppState} from 'src/store/reducers';
import { ChangeAnnStatus,ViewAnnouncement } from 'src/store/actions/announcementActions';
@Injectable({
  providedIn: 'root'
})
export class ViewlinksService {

  constructor(private http: HttpService,private store: Store<AppState>) { }

  
  getAllLink() {
    return this.http.query('get', 'links', {});
  }


  openLock(url) {
    return this.http.query('get', url, {});
  }

  getLinkByToken(token) {
    return this.http.query('get', 'link-token/'+token, {});
  }

  getuser() {
    return this.http.query('get', 'user', {} );
  }

  tupas(payload) {
    return this.http.query('post', 'tupas/redirect', {}, '', payload , 'openId');
  }

  deleteLink(id){
    return this.http.query('delete', 'link/'+id, {});
  }

  expireLink(payload){
    console.log("here is payload service",payload)
    return this.http.query('post', 'change-status', {} , '' , payload);
  }
}
